import React from 'react'

const SupplierGroupForm = () => {
  return (
    <div>SupplierGroupForm</div>
  )
}

export default SupplierGroupForm